import { render, staticRenderFns } from "./ModernTimeDimensionRow.vue?vue&type=template&id=bc398a14&scoped=true"
import script from "./ModernTimeDimensionRow.vue?vue&type=script&lang=js"
export * from "./ModernTimeDimensionRow.vue?vue&type=script&lang=js"
import style0 from "./ModernTimeDimensionRow.vue?vue&type=style&index=0&id=bc398a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc398a14",
  null
  
)

export default component.exports